module.exports = __webpack_public_path__ + "img/ring_g_i_1_1@2x.f7d53fda.png";